export default __webpack_public_path__ + "static/media/e-commerce.0a1a86d5.jpg";